import { useState } from 'react'
import { Button } from 'react-bootstrap'

import { useApprovePackageRequest, useRejectPkgReq } from '../../../../api/package-req'

export const ReturnRequestDetails = ({ item, onApprove, onBack }) => {
  const [labelDownloaded, setLabelDownloaded] = useState(false)
  const approvePackageReqMutation = useApprovePackageRequest()
  const rejectPackageRequestMutation = useRejectPkgReq()

  const approveReq = async () => {
    try {
      //approve package req
      const dataForApprove = {
        packageReqId: item.id,
      }

      const res = await approvePackageReqMutation.mutateAsync(dataForApprove)
      if (res.statusCode !== 200) {
        const message = res.msg || 'Error approving return request'
        alert(message)
        return
      }
      // console.log('approveReq - approveResult:', approveResult)
    } catch (error) {
      console.log('approveReq - error:', error)
      alert('Error Approving Request!', error)
    }
    //reset states
    setLabelDownloaded(false)
    onApprove()
  }

  const onCancelReturnRequest = async rejectReason => {
    const isConfirmed = window.confirm('Are you sure you want to cancel return request?')
    if (!isConfirmed) return

    try {
      const data = {
        packageReqId: item.id,
        rejectReason,
      }

      const res = await rejectPackageRequestMutation.mutateAsync(data)
      if (res.statusCode !== 200) {
        const message = res.msg || 'Error rejecting return request'
        alert(message)
        return
      }
      //reset states
      setLabelDownloaded(false)
      onBack()
    } catch (error) {
      console.log('Error while trying to cancel return request', error)
    }
  }

  return (
    <div className='req-form-cont'>
      <div className='d-flex justify-content-between align-items-center'>
        <h2>Return Package</h2>
        <Button variant='danger' size='sm' className='btn-icon ml-4' onClick={onBack}>
          X
        </Button>
      </div>
      <br />
      <br />
      <div>Download label and print it:</div>
      <br />
      <a href={item.returnLabel} target='_blank' onClick={() => setLabelDownloaded(true)} rel='noreferrer'>
        Download Label
      </a>
      <br />
      <br />
      <br />
      <br />
      <br />
      <Button variant='primary' onClick={approveReq} disabled={!labelDownloaded || approvePackageReqMutation.isPending}>
        Approve
      </Button>

      <div className='reject-reqs-cont'>
        <h4>Reject Request</h4>

        <div className='reject-req-cards-cont'>
          <div className='reject-req-card'>
            <div style={{ fontWeight: 'bold' }}>False Label</div>
            <div>Cant return package because the label is bad.</div>
            <Button
              variant='danger'
              style={{ backgroundColor: 'red' }}
              onClick={() => onCancelReturnRequest('falseLabel')}
              disabled={rejectPackageRequestMutation.isPending}
            >
              Reject
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
